<template>
  <div class="md-layout md-alignment-center-center gray-6 bg">
    <div class="md-layout-item md-size-33">
      <signup-form />
    </div>
  </div>
</template>

<script>
import SignupForm from "../../components/auth/SignupForm";

export default {
  name: 'signup',
  components: {
    SignupForm
  }
};
</script>

<style>
</style>
